// The APIM subscription key and `Product` header AMP hands a child app as
// host.apimSubscriptionKey / host.product, which the child sends on every API call.
//
// Key, per app by slug (upper-cased, anything but a letter or digit becomes "_"):
//   REACT_APP_SUBSCRIPTION_KEY_<SLUG>   e.g. REACT_APP_SUBSCRIPTION_KEY_AMTHERMAL
// An app without its own key gets the shared REACT_APP_CHILD_APPS_APIM_KEY.
//
// Product, the same for every app: REACT_APP_PRODUCT_APIM (AMP's own `Product` header, e.g.
// AMP-UI). It names which Entra authority and audience the token is checked against, at APIM
// and in the service, so it is not a per-app value and not APIM's product name.
//
// An unset or blank value is left out, never sent empty.

type Env = Record<string, string | undefined>;

const slugToken = (slug: string) => slug.toUpperCase().replace(/[^A-Z0-9]/g, "_");

const present = (value: string | undefined) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

export function childApimHeaders(slug: string, env: Env = process.env) {
  return {
    apimSubscriptionKey:
      present(env[`REACT_APP_SUBSCRIPTION_KEY_${slugToken(slug)}`]) ??
      present(env.REACT_APP_CHILD_APPS_APIM_KEY),
    product: present(env.REACT_APP_PRODUCT_APIM),
  };
}
